import { createMenu } from "./create-menu.js";
const getMenuItems = (name, component, page) => {
  const menuDocumentRef = component?.getComponent(name)?.getModels()?.menu;
  const menu = menuDocumentRef && page?.getContent(menuDocumentRef);
  return { menuItems: createMenu(menu, page), menu };
};
export {
  getMenuItems
};
//# sourceMappingURL=get-menu-items.js.map
